import React, { useState } from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear(); // Dynamically get the current year

  // State to manage visibility of Privacy Policy and Terms of Service content
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  // Toggle functions
  const togglePrivacy = (e) => {
    e.preventDefault(); // Prevent scrolling to top
    setShowPrivacy(!showPrivacy);
    setShowTerms(false); // Close Terms if Privacy is toggled
  };

  const toggleTerms = (e) => {
    e.preventDefault(); // Prevent scrolling to top
    setShowTerms(!showTerms);
    setShowPrivacy(false); // Close Privacy if Terms is toggled
  };

  return (
    <footer className="bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white text-center py-4">
      <p className="text-sm font-medium">
        &copy; {currentYear} <span className="font-bold">@TechHook</span>. All
        rights reserved.
      </p>
      <div className="mt-2">
        {/* Buttons to toggle visibility */}
        <button
          onClick={togglePrivacy}
          className="text-white hover:text-gray-300 text-sm bg-transparent border-none cursor-pointer"
        >
          Privacy Policy
        </button>
        <span className="mx-2 text-white">|</span>
        <button
          onClick={toggleTerms}
          className="text-white hover:text-gray-300 text-sm bg-transparent border-none cursor-pointer"
        >
          Terms of Service
        </button>
      </div>

      {/* Privacy Policy content */}
      {showPrivacy && (
        <div className="mt-4 text-sm text-white">
          <p>
            <strong>Privacy Policy:</strong> Your privacy is important to us. We
            collect and store information for the purpose of improving our
            services. We will never sell or share your personal data.
          </p>
        </div>
      )}

      {/* Terms and Conditions content */}
      {showTerms && (
        <div className="mt-4 text-sm text-white">
          <p>
            <strong>Terms and Conditions:</strong> By using our website, you
            agree to comply with all applicable laws and regulations. We reserve
            the right to modify or discontinue any part of our service at any
            time without notice.
          </p>
        </div>
      )}
    </footer>
  );
};

export default Footer;
